import React, { useState, useEffect } from 'react';

import SatModal from '@components/common/satUI/SatModal';
import SatButton from '@components/common/satUI/SatButton';
import SatCheckBox from '@components/common/satUI/SatCheckBox';

const SeniorFinancialCheckList = props => {
  const { visible, setVisible, onOk } = props;

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (!visible && isChecked) setIsChecked(false);
  }, [visible]);

  return (
    <SatModal visible={visible} setVisible={setVisible} wide>
      <header className="modal-header">
        <h3 className="layer-tit2">고령금융소비자 판매 체크리스트</h3>
      </header>
      <div className="cont">
        <div className="info-box mgt-20 mgb-0">
          <p className="tit-small">
            고령 계약자(금융소비자)청약진행시 아래의 유의사항을 확인하고,
            청약절차를 진행하여 주시기 바랍니다.
          </p>
          <ol className="num-list2 mgt-16">
            <li>
              고령금융소비자에 대한 금융상품 상담 및 판매시 내용을 쉽게 인지할
              수 있도록 가급적 쉬운 용어와 느린 속도로 설명합니다.
            </li>
            <li>
              상담결과 고령금융소비자의 사리분별능력이 저하되었다고 판단되는
              경우 판매를 자제합니다.
              <p className="text-info4 asterisk-type mgl--12 mgt-0">
                예시 : 간단한 개념 이해 불가, 기억을 잃어버리는듯한 행동을
                보이는 경우, 의사표시나 대화의 어려움 , 최근 금융거래내역 인지
                불가 등
              </p>
            </li>
            <li>
              보험상품 유의사항(불이익사항)을 우선 안내 합니다.
              <p className="text-info4 asterisk-type mgl--12 mgt-0">
                불이익 사항 : 원금 손실 가능성, 손실가능범위, 중도해지시의
                불이익, 고령금융소비자에게 추가부담이 발생할 수 있는 사항,
                보장이 제한되거나 되지 않는 경우 등
              </p>
            </li>
            <li>
              상품안내에 대한 이해도를 높이도록 합니다.
              <p className="text-info4 asterisk-type mgl--12 mgt-0 block">
                예시 : 쉬운 용어 사용, 글자크기 확대, 그림 또는 표 삽입 등
              </p>
            </li>
            <li>
              고령금융소비자에 대해서는 청약철회, 품질보증제도에 대한 안내를
              강화하여야 합니다.
            </li>
            <li>
              상품판매시 가입목적의 적정성을 고려하여 판매합니다.
              <p className="text-info4 asterisk-type mgl--12 mgt-0">
                예시 : 가족보장, 의료비 마련, 노후소득마련, 저축, 상속․증여 등의
                목적
              </p>
            </li>
          </ol>
          <SatCheckBox
            value={[isChecked]}
            options={[{ label: '위의 내용을 확인하였습니다.', value: '1' }]}
            customStyleClass={'mgt-16'}
            onChange={checked => setIsChecked(checked)}
          />
        </div>
      </div>
      <div className="layer-footer">
        <SatButton
          label={'확인'}
          styleClass={'btn-s blue btn-wide'}
          disabled={!isChecked}
          onClick={onOk}
        />
      </div>
    </SatModal>
  );
};

export default React.memo(SeniorFinancialCheckList);
